import React from 'react';

class MultiChoice extends React.Component {
	onClickOption(option) {
		const next_question_id = option.next_question_id;
		const next_file_id = this.props.current_playlist.next_survey_playlist_file ? this.props.current_playlist.next_survey_playlist_file.id : null;
		const answers_attributes = [{
			question_id: this.props.question.id,
			question_option_id: option.id,
			answered_at: new Date(),
			id: this.props.answer.id,
			respondent_survey_id: this.props.respondent_survey.id,
			survey_file_id: this.props.current_song.survey_file_id,
		}];
		this.props.onAnswerQuestion({
			current_question_id: next_question_id,
			current_file_id: next_question_id ? this.props.current_song.id : next_file_id,
			answers_attributes
		});
	}

	render() {
		const options = this.props.question.question_options.map((option) => {
			return (
				<div key={option.id} className={"question-option"}  onClick={() => {
					this.onClickOption(option);
				}}>
					{option.option_text}
				</div>
			);
		});
		return (
			<div style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				pointerEvents: this.props.disabled ? 'none' : 'auto'
			}}>
				<div style={{
					color: '#000000',
					fontSize: 24,
					fontWeight: 'medium',
					marginTop: 15,
					marginBottom: 28,
					textAlign: 'center'
				}}>{this.props.question.question_text}</div>
				<div style={{
					width: '100%'
				}}>
					{options}
				</div>
			</div>
		);
	}
}

export default MultiChoice;


// WEBPACK FOOTER //
// ./src/components/music/multichoice.jsx